/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminListPoolParticipantsRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {AdminListPoolParticipantsResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const adminListPoolParticipants = (request: AdminListPoolParticipantsRequest, options?: CashRequestOptions) => post<AdminListPoolParticipantsRequest, AdminListPoolParticipantsResponse>("/2.0/cash/admin-list-pool-participants", request, {...options, rejectOnError: true })